<template>
  <SalesPlayDrawerCard>
    <div class="drawer-field">
      <label class="drawer-fieldLabel">Prompt</label>
      <textarea
        class="drawer-fieldTextarea"
        v-model="local.prompt"
        placeholder="e.g. Find mid-sized revenue companies in the AI security space who released an earnings report in the last 3 months"
        rows="4"
        maxlength="2000"
        @blur="applyPrompt"
      />
    </div>

    <div v-if="showNumResults" class="drawer-field">
      <label class="drawer-fieldLabel">Results per run</label>
      <input
        class="drawer-fieldInput"
        style="width: 100px"
        type="number"
        v-model.number="local.num_results"
        min="1"
        max="100"
        @blur="applyNumResults"
      />
      <p class="drawer-hint">How many new candidates to find on each run (1-100).</p>
    </div>
  </SalesPlayDrawerCard>
</template>

<script setup lang="ts">
import { reactive, watch } from 'vue'
import SalesPlayDrawerCard from './SalesPlayDrawerCard.vue'
import { useSalesPlayDraft } from '../../composables/useSalesPlayDraft'

const props = withDefaults(defineProps<{
  playId: string
  pipelineId: string | null
  nodeIndex: number
  showNumResults?: boolean
}>(), {
  showNumResults: true,
})

const { nodes, updateNodeConfig } = useSalesPlayDraft()

const currentConfig = () => nodes.value[props.nodeIndex]?.config || {}

const local = reactive({
  prompt: '',
  num_results: 25,
})

function resetLocal() {
  const cfg = currentConfig()
  local.prompt = cfg.prompt || ''
  local.num_results = cfg.num_results || 25
}

resetLocal()

watch(() => nodes.value[props.nodeIndex]?.config, () => {
  resetLocal()
}, { deep: true })

function applyPrompt() {
  // An empty prompt is never valid — leave the last saved value in place
  // rather than overwriting it with blank.
  if (!local.prompt.trim()) {
    resetLocal()
    return
  }
  updateNodeConfig(props.nodeIndex, { prompt: local.prompt.trim() })
}

function applyNumResults() {
  if (!props.showNumResults) return
  local.num_results = Math.max(1, Math.min(100, local.num_results || 25))
  updateNodeConfig(props.nodeIndex, { num_results: local.num_results })
}
</script>

